export interface ChargeCategory {
    chrcate_id?: number
    chrcate_name?: string
    min_number?: number
    max_number?: number
    member?: boolean
    priority?: number
    rvtiming_start?: number
    rvtiming_end?: number
    max_unit?: number
}
export interface ObjectToChargeCategoryProps {
    chrcate_id?: number | string
    chrcate_name?: string
    min_number?: number | string
    max_number?: number | string
    member?: boolean | string
    priority?: number | string
    rvtiming_start?: number | string
    rvtiming_end?: number | string
    max_unit?: number | string
}
export const ObjectToChargeCategory = (obj: ObjectToChargeCategoryProps): ChargeCategory => {
    return {
        chrcate_id: typeof obj.chrcate_id == 'string' ? parseInt(obj.chrcate_id) : obj.chrcate_id,
        chrcate_name: obj.chrcate_name,
        min_number: typeof obj.min_number == 'string' ? parseInt(obj.min_number) : obj.min_number,
        max_number: typeof obj.max_number == 'string' ? parseInt(obj.max_number) : obj.max_number,
        member: typeof obj.member == 'string' ? obj.member == "1" : obj.member,
        priority: typeof obj.priority == 'string' ? parseInt(obj.priority) : obj.priority,
        rvtiming_start: typeof obj.rvtiming_start == 'string' ? parseInt(obj.rvtiming_start) : obj.rvtiming_start,
        rvtiming_end: typeof obj.rvtiming_end == 'string' ? parseInt(obj.rvtiming_end) : obj.rvtiming_end,
        max_unit: typeof obj.max_unit == 'string' ? parseInt(obj.max_unit) : obj.max_unit,
    }
}